<template>
  <div class="cn-category-header">
    <div class="container">
      <div class="cn-category-header__content">
        <h1 class="cn-category-header__title">
          {{ title }}
        </h1>
        <UiParallelogram
          color="aqua"
          class="cn-category-header__parallelogram cn-category-header__parallelogram-1"
        />
        <UiParallelogram
          color="aqua"
          class="cn-category-header__parallelogram cn-category-header__parallelogram-2"
        />
        <UiParallelogram
          color="aqua"
          class="cn-category-header__parallelogram cn-category-header__parallelogram-3"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import UiParallelogram from '@/components/ui/UiParallelogram';

interface Props {
  title: string;
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-category-header {
  --ab-canyon-category-header-color-bg: var(--ab-canyon-color-primary);
  --ab-canyon-category-header-title-color-text: var(--ab-canyon-color-light);

  background-color: var(--ab-canyon-category-header-color-bg);
  overflow: hidden;
  &__content {
    padding-right: calc(4 * var(--size-base));
    padding-top: var(--size-3xl);
    padding-bottom: var(--size-3xl);
    position: relative;
  }
  &__title {
    color: var(--ab-canyon-category-header-title-color-text);

    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.875rem;
    line-height: 2.25rem;
    z-index: 10;
    position: relative;
    @media (min-width: 1656px) {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
  }
  &__parallelogram {
    border-width: 2px;
    position: absolute;
  }
  &__parallelogram-1 {
    width: 40px;
    height: 65px;
    top: 90px;
    right: 45px;
    @media (min-width: 656px) {
      top: 70px;
      right: 335px;
    }
  }
  &__parallelogram-2 {
    width: 40px;
    height: 80px;
    right: -30px;
    top: -20px;
    @media (min-width: 656px) {
      width: 70px;
      right: 190px;
    }
  }
  &__parallelogram-3 {
    width: 30px;
    height: 45px;
    display: none;
    top: 60px;
    @media (min-width: 656px) {
      display: block;
      right: 100px;
    }
  }
}
</style>
